import { render } from "./BandsList.vue?vue&type=template&id=285fa67a&scoped=true&ts=true"
import script from "./BandsList.vue?vue&type=script&lang=ts"
export * from "./BandsList.vue?vue&type=script&lang=ts"

import "./BandsList.vue?vue&type=style&index=0&id=285fa67a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285fa67a"]])

export default __exports__